import { FormatSettings } from '@progress/kendo-angular-dateinputs';

export const sedmsDateFormat: string = 'MM/DD/YYYY';
export const kendoDateFormat: FormatSettings = {
  displayFormat: 'MM/dd/yyyy',
  inputFormat: 'MM/dd/yyyy',
};
